import Utils from '@/core/utils'
export default class goodsSearch {
  filters = {}
  filterItems = [] // 筛选条件的定义
  constructor(propertyDefinition, areas, condition) {
    const { platform, softwareCode, type, areaName, propertyValues = [] } = condition
    Object.keys(condition).forEach((c) => {
      if (!['areaName', 'propertyValues', 'platform'].includes(c)) {
        this.filters[c] = condition[c]
      }
    })
    // 建筑-材料写死厚度 机电和web端-产品写死品牌和型号
    if (softwareCode === 'AppGarch' && type === 'MATERIAL') {
      this.filterItems.push(
        {
          label: '厚度',
          code: 'thickness',
          dataType: 'Number',
          unitSymbol: 'mm'
        }
      )
    } else if (type === 'PRODUCT' && (softwareCode === 'AppGmep' || ['web', 'r'].includes(platform))) {
      this.filterItems.push(
        {
          label: '品牌',
          code: 'brandName',
          dataType: 'Text',
        },
        {
          label: '产品型号',
          code: 'productModel',
          dataType: 'Text'
        }
      )
    }
    const propLen = propertyDefinition.length
    if (propLen) {
      // 数据类型 Text,Enum,Number,Bool,Int,Range
      for (let i = 0; i < propLen; i++) {
        const definition = propertyDefinition[i]
        const displayProp = propertyValues.find((cp) => cp.code === definition.code)
        const dataType = definition.dataType
        const displayPropDef = {
          label: definition.name,
          code: definition.code,
          dataType: dataType,
          unitSymbol: definition.unitSymbol
        }
        // 注意：Bool值的属性广材不接收 前端过滤掉
        if (dataType !== 'Bool') {
          if (dataType === 'Enum') {
            const optionsArr = definition.enumValues || []
            displayPropDef.values = optionsArr.map((opt) => {
              return {
                code: opt.name,
                name: opt.name
              }
            })
          }
          // 处理初始展示的值
          if (dataType === 'Range') {
            this.filters[definition.code] = displayProp && displayProp.value ? displayProp.value.split('-') : [undefined, undefined]
          } else {
            this.filters[definition.code] = displayProp ? displayProp.value : ''
          }
          this.filterItems.push(displayPropDef)
        }
      }
    }

    this.filters.areaCode = this.getAreaCode(areas, areaName)
  }

  getAreaCode(areas, area) {
    const root = areas.find((a) => !a.parentCode)
    const rootCode = root ? root.code : '1'
    if (area && areas && areas.length) {
      const cities = area.split('-')
      let selectCity
      if (cities.length) {
        if (cities.length > 1) {
          const province = cities[0]
          const city = cities[1]
          selectCity = areas.find((a) => a.name === city && a.parentName === province)
        } else {
          selectCity = areas.find((a) => a.name === cities[0])
        }
        if (selectCity) {
          const { codes } = Utils.getPathByChildCode(areas, selectCity.code, rootCode)
          return codes
        }
      }
    }
    return [rootCode]
  }

  getGoodsSearch() {
    return {
      filters: this.filters,
      filterItems: this.filterItems
    }
  }
}
